import { Injectable } from '@angular/core';
import { IMqttMessage, MqttService } from 'ngx-mqtt';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MQTTservicesService {

  constructor(private _mqttService: MqttService) { }

  topic(topicName: string): Observable<IMqttMessage> {
    // console.log('--------------------- this._mqttService ---------------------',topicName)
    return this._mqttService.observe(topicName);
  }
}
